// sections/DetailHeaderSection.tsx

import { useReceivableDetail } from "../../hooks/useReceivableDetail";

const DetailHeaderSection = () => {
  const { detail } = useReceivableDetail();

  if (!detail) return null;

  const getStatusLabel = (status: string) => {
    const labels: Record<string, string> = {
      PENDING: "Pendiente",
      PARTIAL: "Parcial",
      PAID: "Pagado",
      OVERDUE: "Vencido",
    };

    return labels[status] || status;
  };

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {/* Número */}
        <div
          className="
            rounded-lg
            border border-gray
            bg-gray-2
            p-4
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Número
          </p>

          <h3 className="text-title-xsm font-semibold text-black dark:text-white">
            {detail.number}
          </h3>
        </div>

        {/* Estado */}
        <div
          className="
            rounded-lg
            border border-gray
            bg-gray-2
            p-4
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Estado
          </p>

          <div
            className="
              inline-flex
              rounded-full
              bg-warning/10
              px-3 py-1
              text-sm
              font-medium
              text-warning
            "
          >
            {getStatusLabel(detail.status)}
          </div>
        </div>

        {/* Saldo pendiente */}
        <div
          className="
            rounded-lg
            border border-primary/20
            bg-primary/5
            p-4
            dark:border-primary/30
            dark:bg-primary/10
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Saldo pendiente
          </p>

          <h3 className="text-title-sm font-bold text-primary">
            ${Number(detail.pendingAmount).toFixed(2)}
          </h3>
        </div>
      </div>
    </section>
  );
};

export default DetailHeaderSection;